// extracted by mini-css-extract-plugin
module.exports = {"prices-table":"PricesTable_prices-table__1P0_s","slider":"PricesTable_slider__2qoyX"};